import { CloudinaryCore } from "@/lib/cloudinary";

export default {
  name: "ChatMixin",
  props: {
    message: {
      type: Object,
      required: false,
    },
  },

  methods: {
    messageReactions(message) {
      if (!message || !message.messagereactionSet || message.messagereactionSet.length === 0) return [];
      let reactions = [];
      let msgReactions = message.messagereactionSet;
      msgReactions.forEach((element) => {
        let existingId = reactions.findIndex((r) => r.reaction == element.reaction);
        if (existingId > -1) {
          reactions[existingId]["users"].push(element.user);
        } else {
          reactions.push({
            reaction: element.reaction,
            users: [element.user],
          });
        }
      });

      return reactions;
    },
    getReactionUserList(users) {
      return users.map((element) => element.firstName + " " + element.lastName).join(", ");
    },
    imageGalleryCols(message) {
      if (message?.messageattachmentSet?.length == 0) {
        return 12;
      }
      const numImages = this.getAttachments(message?.messageattachmentSet, 'IMAGE').length;
      if (numImages == 1) {
        return 12;
      }
      if (numImages % 3 == 0) {
        return 4;
      }
      return 6;
    },
    cloudinaryAudioFile(publicId) {
      const url = CloudinaryCore.video_url(publicId, { bit_rate: "50k" });
      return `${url}.mp3`;
    },
    getImageGallery(attachments, firstOnly = false) {
      const images = this.getAttachments(attachments, 'IMAGE');
      const imagesFormatted = images.map((element) => element.file);
      return firstOnly && imagesFormatted?.length > 0 ? imagesFormatted[0] : imagesFormatted;
    },
    getAttachments(attachments, type) {
      const images = attachments.filter((element) => element.type === type);
      return images;
    },
  },
};
